module.exports = __webpack_public_path__ + "media/images/flag-au-38cd70d114fcea6e658bfec1704140e1.svg";